export default "__VITE_ASSET__625e3f6f__"